import { createContext, useContext } from 'react';
import { List } from '../domain';

type ListsContextState = {
  isLoading: boolean;
  couldNotLoad: boolean;
  isSubscribing: boolean;
  didSubscribe: boolean;
  couldNotSubscribe: boolean;
  isUnsubscribing: boolean;
  didUnsubscribe: boolean;
  couldNotUnsubscribe: boolean;
  allLists: List[];
  isSubscribedToList: Record<List['id'], boolean | undefined>;
  resetSubscribe: () => void;
  resetUnsubscribe: () => void;
  subscribe: (toList: List) => void;
  unsubscribe: (fromList: List) => void;
};

export const defaultState: ListsContextState = {
  isLoading: false,
  couldNotLoad: false,
  isSubscribing: false,
  didSubscribe: false,
  couldNotSubscribe: false,
  isUnsubscribing: false,
  didUnsubscribe: false,
  couldNotUnsubscribe: false,
  allLists: [],
  isSubscribedToList: {},
  resetSubscribe: () => null,
  resetUnsubscribe: () => null,
  subscribe: () => null,
  unsubscribe: () => null,
};

export const ListsContext = createContext<ListsContextState>(defaultState);

export const useListsContext = () => useContext(ListsContext);
